export const SET_CURRENT_CUSTOMER = 'SET_CURRENT_CUSTOMER'
